import moment from "moment";
import {InitPage} from "../../index";

declare var $;
declare var set_printer_url;

class Returns {
    init() {
        const _this = this;
        $(".add-pallet").on("click", function() {
            let _id = new Date().getTime();
            let _item_number = $(this).data("item-number");
            let _so_item_id = $(this).data("item-id");
            let html = "";
            $("#item-tag-table-div-"+$(this).data("item-number")).show();
            let lotSelect = "<select name='sales_order_returns[sales_item_tags][" + _so_item_id + "][" +_id + "][lot_number]'>";
            $(this).data("lot-numbers").forEach(function(e) {
                lotSelect += "<option value='" + e + "'>" + e + "</option>";
            });
            lotSelect += "</select>";
            html  = "<tr id="+ _id +" data-item-number="+$(this).data('item-number')+">"
            html += "<td class=\"text-center\">" + lotSelect + "</td>"
            html += "<td class=\"text-center\">" + $(this).data("expiration-date") + "<input type='hidden' name='sales_order_returns[sales_item_tags]["+ _so_item_id +"]["+_id+"][expiration_date]' value='"+ $(this).data("expiration-date") +"'></td>"
            html += "<td class=\"text-center\"><input type='number' name='sales_order_returns[sales_item_tags]["+ _so_item_id +"]["+_id+"][no_of_tags]' value=1 class='tags-qty' data-item-number='" + $(this).data("item-number") + "' oninput='window.r.verifyVal(\"" + _id + "\")'></td>"
            html += "<td class=\"text-center\"><input type='number' name='sales_order_returns[sales_item_tags]["+ _so_item_id +"]["+_id+"][no_of_cases]' value=1 class='case-qty' data-item-number='" + $(this).data("item-number") + "' oninput='window.r.verifyVal(\"" + _id + "\")'></td>"
            html += "<td><a href='#' class='btn btn-red-small' onclick='window.r.removeTagRow(" + _id + ")'><i class='fa fa-trash'></i></a></td>"
            html += "</tr>";
            $('#item-tag-table-'+$(this).data('item-number')).append(html);
            _this.validateItemStatus(_item_number);
        });

        $("#printer").change(function(){
            $.ajax({
              url: set_printer_url,
              method: "POST",
              data: { printer: $(this).val() }
            }).done(function(e){
              console.log(e);
            })
        })

        $(".return-qty").on("input", function() {
            console.log($(this).data("item-number"));
            _this.validateItemStatus($(this).data("item-number"));
        });

        $(document).keypress(
          function(event){
            if (event.which == '13') {
              event.preventDefault();
            }
        });
    }

    updateValItem(i) {
        $("#case-qty-" + i ).val(this.sumTagQtyRow(i))
    }

    removeTagRow (e) {
        const item_number = $("#" + e).data("item-number");
        const caseQty = Number($("#" + e + " .case-qty").val()) || 0;
        const tagQty  = Number($("#" + e + " .tag-qty").val()) || 0;
        $("#" + e).remove();

        $("#case-qty-" + $(this).data("item-number")).val(Number("#case-qty-" + $(this).data("item-number")) - (caseQty * tagQty))
        if($("#item-tag-table-" + item_number + " tr").length == 1) {
            $("#item-tag-table-div-" + item_number).hide();
        }
        this.validateItemStatus(item_number);
    }

    sumTagQtyRow(i) {
        let sum = 0;
        $("#item-tag-table-"+ i + " tbody tr").each(function(){
            let tagsQty = Number($(this).find("td .tags-qty").val()) || 0;
            let caseQty = Number($(this).find("td .case-qty").val()) || 0;
            sum = sum + (tagsQty * caseQty);
        })
        return sum;
    }

    validateItemDetails(i) {
        let validation = true;
        const _parent = $("#item-" + i);
        const _return_qty = _parent.find(".return-qty");

        if(_return_qty.val() != "") {
          const return_value = Number(_return_qty.val()) || 0;
          if(return_value > Number(_return_qty.data("item-qty"))){
            validation = false;
          }
          if(return_value != this.sumTagQtyRow(i)) {
            validation = false;
          }
        } else {
          if(this.sumTagQtyRow(i) != 0) {
            validation = false;
          }
        }
        let total_quantity =_parent.find('.total_items').data('total-items')
        let received_quantity =_parent.find('.received_items').data('received-items')
        if ((total_quantity - received_quantity) < _return_qty.val()){
          validation = false;
          alert(" Total Return Qty cannot be more than Total SO Qty.")
        }
        return validation;
      }

    validateItemStatus(i) {
        if(this.validateItemDetails(i)){
          $("#sales-order-" + i + "-check").show()
          $("#sales-order-" + i + "-cross").hide()
        }
        else {
          $("#sales-order-" + i + "-check").hide()
          $("#sales-order-" + i + "-cross").show()
        }
        this.checkStatus();
    }

    validateSoldItem(i) {
        this.validateItemStatus($(this).data("item-number"))
    }

    checkStatus() {
        if($(".greencheck:visible").length == Number($("#total-so-qty").data("qty"))){
          $("#submit-returns").removeAttr("disabled")
        }
        else {
          $("#submit-returns").attr("disabled", "disabled")
        }
    }

    verifyVal(e) {
        console.log(e);
        this.validateItemStatus($("#" + e).data("item-number"));
        this.updateValItem($("#" + e).data("item-number"));
    }
}

declare global {
    interface Window {
        r: Returns;
    }
}

export function LoadPage() {
    InitPage("returns new", () => {
        const r = new Returns();
        r.init();
        window.r = r;
    });
}
